import { render, staticRenderFns } from "./docDetail.vue?vue&type=template&id=5fe725bd&scoped=true"
import script from "./docDetail.vue?vue&type=script&lang=js"
export * from "./docDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe725bd",
  null
  
)

export default component.exports